import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { connect } from "react-redux";
import { toastError, countryActionId, cityActionId, industryActionId, stateActionId, downloadReport, toastSuccess, sessionExpireMessage, tokenInavlidMessage } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import Pagination from "../../../utils/pagination";
import Header from '../../../common_components/Header';
import { get_userList_action, share_credential_action, userRegistrationRpt_action, get_userList_export_action } from '../../../actions/adminAction/users_action';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

class userList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false, isFilterShow: false,
            isOtherPreName: false,
            MemberId: '', currentPage: 1, usersList: [], recordsPerPage: 10,
            MembershipNo: '', CompanyName: '', EmailAddress: '', IsActive: true,
            userExportList: [],
            FullAccess: false, ReadAccess: false, WriteAccess: false, UpdateAccess: false, DeleteAccess: false, DownloadAccess: false, Is_SpecialAccess: false, SendAccess: false
        }
        this.updateItem = this.updateItem.bind(this);
        this.updateRecordsPerPage = this.updateRecordsPerPage.bind(this);
    }

    componentDidMount() {
        if (!JSON.parse(sessionStorage.getItem("loginDataSS"))) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
            return;
        }
        window.scrollTo(0, 0);

        const loginAccessList = JSON.parse(sessionStorage.getItem('loginAccesslist')) || [];
        const userListModule = loginAccessList.find(module => module.ModuleName === "User List");

        if (userListModule) {
            const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = userListModule;
            if (!FullAccess && !ReadAccess) {
                this.props.navigate('/login'); // Navigate to login if no access
            } else {
                this.setState({
                    FullAccess: !!FullAccess,
                    ReadAccess: !!ReadAccess,
                    WriteAccess: !!WriteAccess,
                    UpdateAccess: !!UpdateAccess,
                    DeleteAccess: !!DeleteAccess,
                    DownloadAccess: !!DownloadAccess,
                    Is_SpecialAccess: !!Is_SpecialAccess,
                    SendAccess: !!SendAccess
                });

                if (FullAccess) {
                    this.setState({
                        ReadAccess: true,
                        WriteAccess: true,
                        UpdateAccess: true,
                        DeleteAccess: true,
                        DownloadAccess: true,
                        Is_SpecialAccess: true,
                        SendAccess: true
                    });
                }
            }
        } else {
            this.props.navigate('/login'); // If "User List" module is missing, redirect to login
        }

        if (loginAccessList.length) {
            this.getFillList(countryActionId, '', '', '', '').then(() => {
                this.getFillList(industryActionId, '', '', '', '').then(() => {
                    this.getUserList();
                    this.getUserListExport();
                });
            });
        }
    }
    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === countryActionId) {
                            this.setState({ countryList: data.data })
                            resolve(true)
                        }
                        else if (actionID === stateActionId) {
                            data.data.length > 0 && this.setState({
                                stateList: data.data,
                                tempStateList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === cityActionId) {
                            data.data.length > 0 && this.setState({
                                cityList: data.data,
                                tempCityList: data.data,
                            })
                            resolve(true)
                        }
                        else if (actionID === industryActionId) {
                            this.setState({
                                industryList: data.data,
                                // tempCityList: data.data,
                            })
                            resolve(true)
                        }
                    }
                })
        })
    }

    getUserList() {
        const { isLoading, MembershipNo, CompanyName, EmailAddress, IsActive } = this.state
        this.setState({ isLoading: true })
        this.props
            .get_userList_action(MembershipNo, CompanyName, EmailAddress, IsActive)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false, usersList: data.data, currentPage: 1 })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    getUserListExport() {
        this.props
            .get_userList_export_action()
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ userExportList: data.data })
                } else {
                    toastError(data.data.ErrorMsg);
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    // OPTION 1: Calculate widths before adding data
    exportExcelData() {
        const { userExportList } = this.state;

        if (userExportList.length === 0) {
            console.warn("No data to export");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('User Export');
        const headers = Object.keys(userExportList[0]);

        // Calculate column widths BEFORE adding data
        const columnWidths = headers.map(header => {
            const headerLength = header.length;
            const maxDataLength = Math.max(
                0,
                ...userExportList.map(row => {
                    const value = row[header];
                    return value ? value.toString().length : 0;
                })
            );
            return Math.min(Math.max(Math.max(headerLength, maxDataLength) + 2, 10), 50);
        });

        // Set column widths
        headers.forEach((header, index) => {
            worksheet.getColumn(index + 1).width = columnWidths[index];
        });

        // Add and style header row
        const headerRow = worksheet.addRow(headers);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, size: 12 };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            };
        });
        headerRow.height = 25;

        // Add data rows
        userExportList.forEach(item => {
            const rowData = headers.map(header => item[header] || '');
            const dataRow = worksheet.addRow(rowData);

            dataRow.eachCell((cell) => {
                cell.alignment = { horizontal: 'left', vertical: 'middle' };
            });
        });

        // Download
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const filename = `UserExport_${timestamp}.xlsx`;

        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, filename);
            console.log(`Excel file exported successfully: ${filename}`);
        }).catch(error => {
            console.error('Error exporting Excel file:', error);
        });
    }

    // OPTION 2: Set fixed reasonable widths based on header names
    exportExcelDataFixedWidths() {
        const { userExportList } = this.state;

        if (userExportList.length === 0) {
            console.warn("No data to export");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('User Export');
        const headers = Object.keys(userExportList[0]);

        // Set intelligent fixed widths based on common column types
        headers.forEach((header, index) => {
            const column = worksheet.getColumn(index + 1);
            const headerLower = header.toLowerCase();

            // Set width based on column name patterns
            if (headerLower.includes('id') || headerLower.includes('code')) {
                column.width = 12;
            } else if (headerLower.includes('name') || headerLower.includes('title')) {
                column.width = 25;
            } else if (headerLower.includes('email')) {
                column.width = 30;
            } else if (headerLower.includes('phone') || headerLower.includes('mobile')) {
                column.width = 15;
            } else if (headerLower.includes('date') || headerLower.includes('time')) {
                column.width = 18;
            } else if (headerLower.includes('address') || headerLower.includes('description')) {
                column.width = 35;
            } else {
                // Default width based on header length
                column.width = Math.max(header.length + 5, 12);
            }
        });

        // Add and style header row
        const headerRow = worksheet.addRow(headers);
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, size: 12 };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
        headerRow.height = 25;

        // Add data rows
        userExportList.forEach(item => {
            worksheet.addRow(headers.map(header => item[header] || ''));
        });

        // Download
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const filename = `UserExport_${timestamp}.xlsx`;

        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, filename);
            console.log(`Excel file exported successfully: ${filename}`);
        });
    }

    // OPTION 3: Manual width calculation with character measurement
    exportExcelDataPreciseWidths() {
        const { userExportList } = this.state;

        if (userExportList.length === 0) {
            console.warn("No data to export");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('User Export');
        const headers = Object.keys(userExportList[0]);

        // Function to estimate text width (approximate)
        const getTextWidth = (text) => {
            if (!text) return 0;
            const str = text.toString();
            // Rough estimate: most characters are about 1 unit, numbers slightly less
            return str.length * 1.2;
        };

        // Add all data first
        const headerRow = worksheet.addRow(headers);
        userExportList.forEach(item => {
            worksheet.addRow(headers.map(header => item[header] || ''));
        });

        // Calculate and set column widths after data is added
        headers.forEach((header, colIndex) => {
            let maxWidth = getTextWidth(header);

            // Check each data row for this column
            for (let rowIndex = 2; rowIndex <= worksheet.rowCount; rowIndex++) {
                const cell = worksheet.getCell(rowIndex, colIndex + 1);
                const cellWidth = getTextWidth(cell.value);
                if (cellWidth > maxWidth) {
                    maxWidth = cellWidth;
                }
            }

            // Set width with padding and limits
            worksheet.getColumn(colIndex + 1).width = Math.min(Math.max(maxWidth + 2, 8), 50);
        });

        // Style header row
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, size: 12 };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFD3D3D3' }
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
        });
        headerRow.height = 25;

        // Download
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const filename = `UserExport_${timestamp}.xlsx`;

        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            saveAs(blob, filename);
            console.log(`Excel file exported successfully: ${filename}`);
        });
    }
    navigateUser(MemberId, Mode) {
        this.props.navigate('/user_details', {
            state: {
                MemberId: MemberId, Mode: Mode
            }
        })
    }
    shareCredential(MemberID) {
        this.setState({ isLoading: true })
        this.props
            .share_credential_action(MemberID)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    this.setState({ isLoading: false }, () => toastSuccess(data.data))
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            }).catch((e) => {
                console.log(e);
                this.setState({ isLoading: false });
            });
    }
    updateItem(item) {
        this.setState({ currentPage: item });
    }
    updateRecordsPerPage = (count) => {
        this.setState({ recordsPerPage: count, currentPage: 1 }, () => window.scrollTo(0, 0));
    };
    onUserRegistrationDownload(E, id) {
        this.setState({ isLoading: true })
        this.props.userRegistrationRpt_action(id)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    console.log("Proforma Pdf Download", data)
                    var url = `${downloadReport}?SessionIdentifier=${data}&Export=true`;
                    const win = window.location.replace(url, '_blank');
                    if (win != null) {
                        win.focus();
                    }
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })

    }
    userRecord(usersList) {
        const { FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = this.state
        return (
            <table className="table table-bordered table-striped mg-b-0">
                <thead>
                    <tr>
                        <th>Registration No</th>
                        <th style={{ width: "30%" }}>Company Name</th>
                        {/* <th>Industry</th> */}
                        <th>Country</th>
                        <th>Email</th>
                        <th>Status</th>
                        <th className="text-center" style={{ width: "18%" }}>
                            Action
                        </th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {usersList.length > 0 ? usersList.map((data, i) => (
                        <tr key={i}>
                            <td>{data.MembershipNo}</td>
                            <td>{data.CompanyName}</td>
                            {/* <td>{data.IndustryName}</td> */}
                            <td>{data.CountryName}</td>
                            <td>{data.EmailAddress}</td>
                            <td>{data.IsActive == 1 ? 'Active' : 'Inactive'}</td>
                            <td className="text-center" >
                                <div className='user-list'>
                                    {ReadAccess && <>
                                        <a
                                            onClick={() => this.navigateUser(data.MemberId, 'view')}
                                            href="javascript:void(0);"
                                            title="View"
                                            className="load_document_icon mx-2"
                                            data-toggle="modal"
                                            data-target="#add_comment_modal"
                                        >
                                            <i className="fa fa-eye" />
                                        </a>
                                    </>}
                                    {UpdateAccess && <>
                                        <a
                                            onClick={() => this.navigateUser(data.MemberId, 'edit')}
                                            href="javascript:void(0);"
                                            title="Edit"
                                            className="load_document_icon mx-2"
                                            data-toggle="modal"
                                            data-target="#add_comment_modal"
                                        >
                                            <i className="fa fa-edit" />
                                        </a>
                                    </>}
                                    {DownloadAccess && <>
                                        <a
                                            href="javascript:void(0);"
                                            title="Download Document"
                                            className="load_document_icon mx-2"
                                            data-toggle="modal"
                                            data-target="#add_comment_modal"
                                            onClick={(e) => this.onUserRegistrationDownload(e, data.MemberId)}
                                        >
                                            <i className="fa fa-file-text" />
                                        </a>
                                    </>}
                                    {SendAccess && <>
                                        <a
                                            href="javascript:void(0);"
                                            title="Send Credentials"
                                            onClick={() => this.shareCredential(data.MemberId)}
                                            className="load_document_icon  p-1 pb-2 px-2 send_credentials-btn mx-1"
                                            data-toggle="modal"
                                            data-target="#add_comment_modal"
                                        >
                                            Send Credentials
                                        </a>
                                    </>}
                                </div>
                            </td>
                        </tr>
                    )) : <>
                        <tr>
                            <td colSpan={6}>No Records Found...</td>
                        </tr>
                    </>}
                </tbody>
            </table>
        );
    }
    toggleFilterCollapse() {
        this.setState((prevstate) => ({
            isFilterShow: !prevstate.isFilterShow
        }))
    }
    clearFilter() {
        this.setState({ CompanyName: '', MembershipNo: '', EmailAddress: '', IsActive: true }, () => this.getUserList())
    }
    render() {
        const { isLoading, currentPage, usersList, isFilterShow, MembershipNo, CompanyName, EmailAddress, IsActive, recordsPerPage, userExportList,
            FullAccess, ReadAccess, WriteAccess, UpdateAccess, DeleteAccess, DownloadAccess, Is_SpecialAccess, SendAccess } = this.state
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        const currentRecords = usersList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(usersList.length / recordsPerPage);
        return (
            <>
                {isLoading ? (
                    // <Loader></Loader>
                    <></>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <div class="row mt-15">
                            <section className="table_section">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-12 col-sm-12 col-lg-12">
                                            <div className="card shadow-none border mb-2" >
                                                <div className="card-header py-1">
                                                    <h6 className='pt-2' style={{ float: 'left' }}>Users</h6>
                                                    {(JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Super Admin' || JSON.parse(sessionStorage.getItem('loginDataSS')).RoleName == 'Admin') ? <>
                                                        <div style={{ float: 'right' }}>
                                                            <a className="load_document_icon  p-1 pb-2 px-2 send_credentials-btn mx-1" onClick={() => this.exportExcelData()}>Export</a>
                                                            <a href="javascript:void(0);"
                                                                className="btn btn-purple custom_btn"
                                                                title="Filter"
                                                                data-toggle="modal"
                                                                data-target="#filter_modal"
                                                                onClick={() => this.toggleFilterCollapse()}
                                                            >
                                                                <i className="fa fa-filter" />
                                                            </a>
                                                        </div>

                                                    </> : <></>}
                                                </div>
                                                <ul className="list-group list-group-flush">
                                                    {isFilterShow && <>

                                                        <li className="list-group-item"><div className="row">
                                                            <div class="col-md-2">
                                                                <div class="form-group">
                                                                    <label>Registration No<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Registration No" value={MembershipNo} onChange={(e) => this.setState({ MembershipNo: e.target.value })} maxLength={100} />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <div class="form-group">
                                                                    <label>Company Name<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Company name" value={CompanyName} onChange={(e) => this.setState({ CompanyName: e.target.value })} maxLength={250} />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <div class="form-group">
                                                                    <label>Email Address<span className="red-star text-danger">*</span></label>
                                                                    <input type="text" class="form-control" placeholder="Enter Email Address" value={EmailAddress} onChange={(e) => this.setState({ EmailAddress: e.target.value })} maxLength={250} />
                                                                </div>
                                                            </div>
                                                            <div class="col-md-2">
                                                                <div class="form-group">
                                                                    <label>Status<span className="red-star text-danger">*</span></label>
                                                                    <select className="form-control" value={IsActive} id="privileges" onChange={(e) => this.setState({ IsActive: e.target.value })}>
                                                                        <option value={''}>Select</option>
                                                                        <option value={1}>Active</option>
                                                                        <option value={0}>InActive</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-2 mb-3">
                                                                < button style={{ marginTop: '20px' }} className='btn btn-primary mr-2' onClick={() => this.getUserList()}>
                                                                    Search
                                                                </button>
                                                                <button type="button" style={{ marginTop: '20px' }} className='btn btn-dark mr-2 ms-2' onClick={e => this.clearFilter()}>
                                                                    Clear
                                                                </button>
                                                            </div>
                                                        </div></li>
                                                    </>}
                                                </ul>
                                            </div>
                                            <div className="card shadow-none border">
                                                <div className="card-body  p-2 pb-0">

                                                    <div className="custom_table">
                                                        <div className="hack1">
                                                            <div className="hack2">
                                                                {this.userRecord(currentRecords)}
                                                                {usersList.length > 0 ? (
                                                                    <Pagination
                                                                        nPages={nPages}
                                                                        currentPage={currentPage}
                                                                        setCurrentPage={this.updateItem}
                                                                        totalRecords={usersList.length}
                                                                        pageLength={recordsPerPage}
                                                                        setPageLength={this.updateRecordsPerPage}
                                                                    />
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </div >
                </section >
                {/* <Footer /> */}

            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, get_userList_action, share_credential_action, userRegistrationRpt_action, get_userList_export_action })(userList));
